import * as yup from 'yup';

export const compareValidation = yup.object().shape({
    title: yup.string().required('Title is required').trim('Title should not have spaces around').max(25, `Title length should be less than 25`),
});